/**
 * @generated SignedSource<<8879fcf2bec4aaf186f7a8ce805ea428>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CartNav_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentType": "CartNav_user";
};
export type CartNav_user$key = {
  readonly " $data"?: CartNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"CartNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f351b99987f2bcc4807ea882d65ff8ad";

export default node;
